(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-lyf-muli-buy"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll(".multi-buy-label").forEach(selector => {
      if(!selector.classList.contains('sold-out')){
      selector.addEventListener('click', event => {
        var available = event.currentTarget.getAttribute("upsell_available")
        var productVariant = event.currentTarget.getAttribute("variant");
        if(available == "true"){
        document.querySelectorAll(".upsell-item").forEach(item => {
          if(item.getAttribute('parent-product') == productVariant) {
            item.style.setProperty("display", "grid");
            item.scrollIntoView(true);
          } else {
            item.style.setProperty("display", "none");
          }
        });
        document.querySelector(".order-now-floating-bar").style.setProperty("display", "none");
        var price = selector.querySelector(".multi-buy-price").innerHTML;
        document.querySelector(".checkout-floating-bar .total-price").innerHTML = price;
        document.querySelector(".checkout-floating-bar").style.setProperty("display", "grid");
        }else{
        var quantity = event.currentTarget.getAttribute("quantity");
        var data = {
          items: [
            {
              id: productVariant,
              quantity: quantity
            }
          ]
        }
        postAndRedirect(data)
        }
      });
      }
    });

    document.querySelector(".floating-bar-order-button").addEventListener("click", event => {
      document.querySelector(".multi-buy-heading").scrollIntoView(true);
    });

    document.querySelectorAll('.upsell-reject-text, .checkout-button').forEach(selector => {
      selector.addEventListener('click', event => {
        var label = document.querySelector("input:checked + label");
        var input = document.querySelector("input:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            }
          ]
        }
        postAndRedirect(data)
      })
    })

    document.querySelectorAll('.upsell-accept-button').forEach(button => {
      button.addEventListener('click', event => {
        var label = document.querySelector("input:checked + label");
        var input = document.querySelector("input:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var upsellVariant = event.target.getAttribute("variant");
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            },
            {
              id: upsellVariant,
              quantity: 1
            }
          ]
        }
        postAndRedirect(data)
      })
    });

    function postAndRedirect(data){
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
      'Content-Type': 'application/json'
      },
        body: JSON.stringify(data)
      })
  .then(response => {
    window.location.href= window.Shopify.routes.root + 'cart'
  })
  .catch((error) => {
    console.error('Error:', error);
  });
    }
  //test

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-with-upsell"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll(".multi-buy-label").forEach(selector => {
      if(!selector.classList.contains('sold-out')){
      selector.addEventListener('click', event => {
        var available = event.currentTarget.getAttribute("upsell_available")
        var productVariant = event.currentTarget.getAttribute("variant");
        if(available == "true"){
        document.querySelectorAll(".upsell-item").forEach(item => {
          if(item.getAttribute('parent-product') == productVariant) {
            item.style.setProperty("display", "grid");
            item.scrollIntoView(true);
          } else {
            item.style.setProperty("display", "none");
          }
        });
        document.querySelector(".order-now-floating-bar").style.setProperty("display", "none");
        var price = selector.querySelector(".multi-buy-price").innerHTML;
        document.querySelector(".checkout-floating-bar .total-price").innerHTML = price;
        document.querySelector(".checkout-floating-bar").style.setProperty("display", "grid");
        }else{
        var quantity = event.currentTarget.getAttribute("quantity");
        var data = {
          items: [
            {
              id: productVariant,
              quantity: quantity
            }
          ]
        }
        postAndRedirect(data)
        }
      });
      }
    });

    document.querySelector(".floating-bar-order-button").addEventListener("click", event => {
      document.querySelector(".multi-buy-heading").scrollIntoView(true);
    });

    document.querySelectorAll('.upsell-reject-text, .checkout-button').forEach(selector => {
      selector.addEventListener('click', event => {
        var label = document.querySelector("input:checked + label");
        var input = document.querySelector("input:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            }
          ]
        }
        postAndRedirect(data)
      })
    })

    document.querySelectorAll('.upsell-accept-button').forEach(button => {
      button.addEventListener('click', event => {
        var label = document.querySelector("input:checked + label");
        var input = document.querySelector("input:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var upsellVariant = event.target.getAttribute("variant");
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            },
            {
              id: upsellVariant,
              quantity: 1
            }
          ]
        }
        postAndRedirect(data)
      })
    });

    function postAndRedirect(data){
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
      'Content-Type': 'application/json'
      },
        body: JSON.stringify(data)
      })
  .then(response => {
    window.location.href= window.Shopify.routes.root + 'cart'
  })
  .catch((error) => {
    console.error('Error:', error);
  });
    }
  //test

  } catch(e) { console.error(e); }
})();
})();
